import React from 'react';
import Tooltip from '@cpg-its/ads.common.tooltip';
import { SortButton } from '../../../../search/components/sort';
import { SearchProps } from '../../models/arc-epi-props';

import { tcsmColors } from '../../../../global/constants/theme/theme-constants/colors';

interface BillingAccountsListLabelsProps {
	settings: SearchProps,
}

export const BillingAccountsListLabels = (props: BillingAccountsListLabelsProps) => {

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.accountNumberLabel} name='account_number' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.accountNameLabel} name='account_name' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.accountCityLabel} name='billing_city' />
			</div>
			<div className='sort-table-row-cell'>
				<p className='input-label'>{props.settings?.enrolledMembersLabel}</p>
			</div>
			<div className='sort-table-row-cell'>
				<span className='input-label'>{props.settings?.amountDueLabel}</span>
        <Tooltip iconColor={tcsmColors.blue} title={props.settings?.amountDueTooltipLabel} />
			</div>
			<div className='sort-table-row-cell'>
				<span className='input-label'>{props.settings?.billingHistoryLabel}</span>
        <Tooltip iconColor={tcsmColors.blue} title={props.settings?.billingHistoryTooltipLabel} />
			</div>
		</div>
	);

};
